module.exports = __webpack_public_path__ + "static/media/main-logo.02b96b04.png";